import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';

import {
  NotePayCycleCreate,
  NotePayCycleCreateVariables,
} from 'ap/paymentCycle/view/ActionMenu/PayCycleNotes/__generated__/NotePayCycleCreate';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';
import { NotesSectionProps } from 'common/components/NotesSection';

import ADD_NEW_NOTE from '../../../../../view/ActionMenu/PayCycleNotes/NotePayCycleCreate.graphql';

type PayCycleAccountingNotesProps = {
  payCycleId: string;
  data: NotesEntityFields[];
  loading?: boolean;
  listRefreshRequest?: NotesSectionProps['listRefreshRequest'];
};

export const PayCycleAccountingNotesSection: React.FC<
  PayCycleAccountingNotesProps
> = ({ payCycleId, data, loading, listRefreshRequest }) => {
  return (
    <GenericNotesSection<
      any,
      NotePayCycleCreate, // TMutationResult
      NotePayCycleCreateVariables // TMutationVariables
    >
      entityId={payCycleId}
      data={data}
      loading={loading}
      mutationDocument={ADD_NEW_NOTE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
